// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { Tools } from "@comunicare/comunicare-helper";
import { AbstractQuestionnaireResponse } from "@comunicare/comunicare-interfaces";

export class QuestionnaireResponse extends AbstractQuestionnaireResponse {
  protected genId(): string {
    return Tools.genValidId();
  }
  protected newQuestionnaireResponse(): AbstractQuestionnaireResponse {
    return new QuestionnaireResponse();
  }
}
